/* A field, or a few, with its buttons beside it (APP-128). A field's help and error text sit
   inside it, under the input, so the row lines up by the top and the buttons drop by the label's
   line to sit level with the input, whatever is written under it. Too narrow for both, the
   buttons go under the fields with no drop. */
.row {
  /* The label's line (14 px at the page's 1.5 line height) and the field's 8 px gap. */
  --field-input-offset: calc(14px * 1.5 + 8px);
  container-type: inline-size;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: flex-start;
  width: 100%;
}

/* Several fields share the space and line up by their labels, as a field row does. */
.fields {
  composes: field-row from global;
  display: grid;
  flex: 1 1 0;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 14px 16px;
  align-items: start;
  min-width: 0;
  /* A host can keep a short field short (a dollar amount) with --field-max-width. */
  max-width: var(--field-max-width, none);
}

/* The buttons centre on the input's 44 px, so smaller ones (amount chips) sit level with it too. */
.actions {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;
  min-height: var(--control-height);
  margin-top: var(--field-input-offset);
}

@container (width < 480px) {
  .fields {
    flex-basis: 100%;
    max-width: none;
  }

  .actions {
    flex: 1 1 100%;
    margin-top: 0;
  }
}
